import { render, staticRenderFns } from "./aboutResearch.vue?vue&type=template&id=0ac1d890&scoped=true&"
import script from "./aboutResearch.vue?vue&type=script&lang=js&"
export * from "./aboutResearch.vue?vue&type=script&lang=js&"
import style0 from "./aboutResearch.vue?vue&type=style&index=0&id=0ac1d890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1d890",
  null
  
)

export default component.exports